import { Nilable } from "@shared/utils";

export interface ICanjeResultadoDTO {
    exchange_type: string;
    status: string | number;
    message: string;
    error_message: Nilable<string>;
    voucher: Nilable<string>;
    error: Nilable<any>;
}

export class CanjeResultadoDTO {
    public tipoCanje = "";
    public estado: string | number = "REQUESTED";
    public mensaje = "";
    public mensajeError = "";
    public voucher = "";
    public error: Nilable<any>;

    constructor(json: Nilable<Partial<ICanjeResultadoDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ICanjeResultadoDTO>) {
        if (json.exchange_type != null) {
            this.tipoCanje = json.exchange_type;
        }
        if (json.status != null) {
            this.estado = json.status;
        }
        if (json.message != null) {
            this.mensaje = json.message;
        }
        if (json.error_message != null) {
            this.mensajeError = json.error_message;
        }
        if (json.voucher != null) {
            this.voucher = json.voucher;
        }
        this.error = json.error;
    }

    public toJSON(): ICanjeResultadoDTO {
        return {
            exchange_type: this.tipoCanje,
            status: this.estado,
            message: this.mensaje,
            error_message: this.mensajeError,
            voucher: this.voucher,
            error: this.error
        };
    }
}
